import pathsManifest from './pathsManifest';
import DevPage from './components/pages/DevPage';
import DashboardPage from './components/pages/DashboardPage';
import InquiryFeedbackPage from './components/pages/InquiryFeedbackPage';
import InquiryFeedbackSuccessPage from './components/pages/InquiryFeedbackSuccessPage';
import TourFeedbackPage from './components/pages/TourFeedbackPage';
import TourFeedbackSuccessPage from './components/pages/TourFeedbackSuccessPage';
import PropertyReviewGuidelinesPage from './components/pages/PropertyReviewGuidelinesPage';
import TermsPage from './components/pages/TermsPage';
import NativeAppSignInPage from './components/pages/NativeAppSignInPage';
import RatingAndReviewRoute from './components/pages/RatingAndReviewRoute';
import MoveInFeedbackPage from './components/pages/MoveInFeedbackPages';
import MoveInFeedbackSuccessPage from './components/pages/MoveInFeedbackSuccessPage';
import {
  AuthenticatedTestPage,
  StrongAuthenticatedTestPage,
  UnauthenticatedTestPage,
} from './components/pages/AuthenticationTestPage';
import IpCheckPage from './components/pages/IpCheckPage';
import WaitlistConfirmationPage from './components/pages/WaitlistConfirmationPage';
import UserActions from './flux/actions/UserActions';
import RatingAndReviewActions from './flux/actions/RatingAndReviewActions';
import NotFoundPage from './components/pages/NotFoundPage';

/*
 * NOTE: if you are planning to use AuthCheck with the requireStrongAuthentication prop set to TRUE
 * you must include the pageWithSensitiveInformation prop on the associated route
 * this ensures the correct api call is made on the server for user information
 */

const routes = [
  {
    exact: true,
    strict: false,
    component: DevPage,
    path: '/',
  },
  {
    exact: true,
    component: DashboardPage,
    path: pathsManifest.dashboard,
  },
  {
    exact: true,
    component: InquiryFeedbackPage,
    path: pathsManifest.inquiryFeedbackPage + '(/)?([?].*)?',
    serverRouteWillMount: (req, res) => {
      const { store } = res.locals;

      const dispatch = store.dispatch;

      if (req.query.inquiryId && req.query.inquiryFeedbackType) {
        const feedbackBody = {
          submittedFeedbackCode: parseInt(req.query.inquiryFeedbackType),
          hash: req.query.hash || '',
          inquiryId: req.query.inquiryId,
        };

        dispatch(UserActions.submitFeedbackWithoutReport(feedbackBody));
      }
    },
  },
  {
    exact: true,
    component: TourFeedbackPage,
    path: pathsManifest.tourFeedbackPage + '(/)?([?].*)?',
  },
  {
    exact: true,
    component: TourFeedbackSuccessPage,
    path: pathsManifest.tourFeedbackSuccessPage + '(/)?([?].*)?',
  },
  {
    exact: true,
    component: InquiryFeedbackSuccessPage,
    path: pathsManifest.inquiryFeedbackSuccessPage + '(/)?([?].*)?',
  },
  {
    component: TermsPage,
    path: pathsManifest.termsPage + '(/)?([?].*)?',
  },
  {
    pageWithSensitiveInformation: true,
    component: NativeAppSignInPage,
    path: pathsManifest.nativeAppSignInPage + '(/)?([?].*)?',
  },
  {
    exact: true,
    component: RatingAndReviewRoute,
    path: pathsManifest.propertyRatingAndReviewBase + '(/)?([?].*)?',
    serverRouteWillMount: (req, res) => {
      const { store } = res.locals;
      const { dispatch } = store;

      if (store.getState().user.loggedIn) {
        if (req.query.tenantType) {
          dispatch(RatingAndReviewActions.editTenantType(req.query.tenantType));
        }

        if (req.query.propertyRating) {
          dispatch(RatingAndReviewActions.editPropertyRating(req.query.propertyRating));
        }

        if (req.query.propertyManagerRating) {
          dispatch(RatingAndReviewActions.editManagerRating(req.query.propertyManagerRating));
        }

        if (req.query.providerListingId) {
          return dispatch(
            RatingAndReviewActions.fetchListingByAliasEncoded({
              aliasEncoded: req.query.providerListingId,
              components: 'photos,basic',
            }),
          );
        } else {
          return Promise.resolve();
        }
      }

      return Promise.resolve();
    },
  },

  {
    exact: true,
    component: PropertyReviewGuidelinesPage,
    path: pathsManifest.propertyReviewGuidelinesPage + '(/)?([?].*)?',
  },

  {
    exact: true,
    component: MoveInFeedbackPage,
    path: pathsManifest.moveInFeedbackPage + '(/)?([?].*)?',
  },

  {
    exact: true,
    component: MoveInFeedbackSuccessPage,
    path: pathsManifest.moveInFeedbackSuccessPage + '(/)?([?].*)?',
  },

  {
    exact: true,
    component: AuthenticatedTestPage,
    path: pathsManifest.authenticatedTestPage + '(/)?([?].*)?',
  },
  {
    exact: true,
    component: UnauthenticatedTestPage,
    path: pathsManifest.unauthenticatedTestPage + '(/)?([?].*)?',
  },
  {
    exact: true,
    component: StrongAuthenticatedTestPage,
    pageWithSensitiveInformation: true,
    path: pathsManifest.strongAuthenticatedTestPage + '(/)?([?].*)?',
  },
  {
    exact: true,
    component: WaitlistConfirmationPage,
    pageWithSensitiveInformation: true,
    path: pathsManifest.waitlistConfirmationPage + '(/)?([?].*)?',
  },
  {
    exact: true,
    component: IpCheckPage,
    pageWithSensitiveInformation: false,
    path: pathsManifest.ipCheckPage,
    serverRouteWillMount: (req, res) => {
      const { store } = res.locals;

      store
        .dispatch(UserActions.getIp())
        .then((response) => {
          return store.dispatch(
            UserActions.updateUserInfo({
              ipFromJava: response,
            }),
          );
        })
        .catch(() => {});
    },
  },
  {
    component: NotFoundPage,
    path: '*',
  },
];

export default routes;
